export const colorStyles = {
	".smartyAddress__color_dark": {
		"--smartyAddress__textBasePrimaryColor": "#fff",
		"--smartyAddress__textBaseSecondaryColor": "#e6e9ed",
		"--smartyAddress__textAccentColor": "#6699ff",

		"--smartyAddress__surfaceBasePrimaryColor": "#111",
		"--smartyAddress__surfaceBaseSecondaryColor": "#383e48",
		"--smartyAddress__surfaceBaseTertiaryColor": "#666",
		"--smartyAddress__surfaceBasePrimaryInverseColor": "#eee",

		"--smartyAddress__strokeBasePrimaryColor": "#666",
		"--smartyAddress__surfaceInverseExtremeColor": "#fff",

		"--smartyAddress__logoDarkDisplay": "none",
		"--smartyAddress__logoLightDisplay": "block",

		"--smartyAddress__largeShadow1": "0 12px 24px 0 rgba(4, 34, 75, 0.10)",
		"--smartyAddress__largeShadow2": "0 20px 40px 0 rgba(21, 27, 35, 0.06)",
	},
	".smartyAddress__color_light": {
		"--smartyAddress__textBasePrimaryColor": "#000",
		"--smartyAddress__textBaseSecondaryColor": "#49505b",
		"--smartyAddress__textAccentColor": "#0066ff",

		"--smartyAddress__surfaceBasePrimaryColor": "#fcfcfc",
		"--smartyAddress__surfaceBaseSecondaryColor": "#ebebeb",
		"--smartyAddress__surfaceBaseTertiaryColor": "#eeeeee",
		"--smartyAddress__surfaceBasePrimaryInverseColor": "#333",

		"--smartyAddress__strokeBasePrimaryColor": "#ccc",
		"--smartyAddress__surfaceInverseExtremeColor": "#000",

		"--smartyAddress__logoDarkDisplay": "block",
		"--smartyAddress__logoLightDisplay": "none",

		"--smartyAddress__largeShadow1": "0 12px 24px 0 rgba(4, 34, 75, 0.10)",
		"--smartyAddress__largeShadow2": "0 20px 40px 0 rgba(21, 27, 35, 0.06)",
	},
};
